"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessingStatus = exports.AssetType = void 0;
/**
 * Enums
 */
var AssetType;
(function (AssetType) {
    AssetType["Video"] = "Video";
    AssetType["Image"] = "Image";
    AssetType["Audio"] = "Audio";
    AssetType["Document"] = "Document";
})(AssetType || (exports.AssetType = AssetType = {}));
var ProcessingStatus;
(function (ProcessingStatus) {
    ProcessingStatus["Pending"] = "Pending";
    ProcessingStatus["Processing"] = "Processing";
    ProcessingStatus["Complete"] = "Complete";
    ProcessingStatus["Failed"] = "Failed";
})(ProcessingStatus || (exports.ProcessingStatus = ProcessingStatus = {}));
//# sourceMappingURL=asset-types.js.map